<div>
  <div class="member">
    <div class="grid col-12 p-0">
      <div class="col-fixed p-0 member-foto" style="width: 100px" *ngIf="!minimize">
        <div class="background">
          <img
            src="{{ appSettings.settings.urlFileDownload }}/competitor/uid/{{
              competitor.registration.user.photo && competitor.registration.user.photo.length > 10 ? competitor.registration.user.photo : appSettings.settings.emptyUserPhoto
            }}?width=82"
          />
          <div class="col-fixed flag fi fi-{{ competitor.registration.user.citizenship }}" style="width: 15px"></div>
        </div>
      </div>
      <div *ngIf="minimize" class="col-12 mini">{{ competitor.registration.user.name }} </div>
      <div class="grid col-12" *ngIf="minimize">
        <div class="col-fixed number">{{ competitor.registration.startNumber }}</div>
        <div class="col info">
          <div class="col-12 p-0">{{ competitor.registration.user.city }}</div>
          <div class="col-12 p-0">{{ competitor.registration.user.team }}</div>
          <div class="col-12 p-0">{{ competitor.registration.user.info }}</div>
        </div>
      </div>

      <div class="col p-0">
        <div class="col-12 p-0 other-data-line">
          <span>{{ appSettings.translate[appSettings.selectedLang]['position'] }}</span>
          <span class="space"></span>
          <span class="position-value">{{ competitor.racePosition }}</span>
        </div>
        <div class="col-12 p-0 other-data-line">
          <span>{{ appSettings.translate[appSettings.selectedLang]['start'] }}</span>
          <span class="space"></span>
          <span>{{ competitor.startTime | date : 'HH:mm:ss' : selectedRace.offset }}</span>
        </div>
        <div class="col-12 p-0 other-data-line">
          <span>{{ appSettings.translate[appSettings.selectedLang]['finish'] }}</span>
          <span class="space"></span>
          <span>{{ competitor.finTime | date : 'HH:mm:ss' : selectedRace.offset }}</span>
        </div>
        <div class="col-12 p-0 other-data-line">
          <span>{{ appSettings.translate[appSettings.selectedLang]['common_time'] }}</span>
          <span class="space"></span>
          <span class="orange">{{ competitor.raceTime  | timePeriodPipe : timeFormat }}</span>
        </div>
        <div class="col-12 p-0 other-data-line">
          <span>{{ appSettings.translate[appSettings.selectedLang]['bestLap'] }}</span>
          <span class="space"></span>
          <span>{{ competitor.bestTime | timePeriodPipe : timeFormat }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 p-0" *ngIf="!minimize">
      <b>{{ competitor.registration.user.name }} </b>
    </div>
    <div class="grid col-12" *ngIf="!minimize">
      <div class="col-fixed number">{{ competitor.registration.startNumber }}</div>
      <div class="col info">
        <div class="col-12 p-0">{{ competitor.registration.user.city }}</div>
        <div class="col-12 p-0">{{ competitor.registration.user.team }}</div>
        <div class="col-12 p-0">{{ competitor.registration.user.info }}</div>
      </div>
    </div>
  </div>
</div>
